module.exports = __webpack_public_path__ + "static/media/dog.10a477b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/dog.mp3
// module id = GDcB
// module chunks = 5